import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const BindersIcon = ({
  color = 'foraBlue',
  width = 18,
  marginLeft,
  marginRight,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill={getSemanticTextColor(color)}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3236 1.86625L18.8237 1L21.9999 20.8963L16.4999 21.6251L13.3236 1.86625ZM14.9049 3.22751L15.7849 8.78253L18.8787 8.28753L17.9987 2.73251L14.9049 3.22751ZM17.3524 18.6551C17.4899 19.5076 18.2874 20.0851 19.1399 19.9476C19.9924 19.8101 20.5699 19.0126 20.4324 18.1601C20.2949 17.3076 19.4974 16.7301 18.6449 16.8676C17.7924 17.0051 17.2149 17.8026 17.3524 18.6551ZM0 21.625H5.56877V1.32994H0V21.625ZM2.79126 20.3738C1.92501 20.3738 1.22375 19.6725 1.22375 18.8063C1.22375 17.94 1.92501 17.2388 2.79126 17.2388C3.65751 17.2388 4.35877 17.94 4.35877 18.8063C4.35877 19.6725 3.65751 20.3738 2.79126 20.3738ZM1.22375 3.19995H4.34502V8.82372H1.22375V3.19995ZM7.75484 1.32994V21.625H13.3236V1.32994H7.75484ZM10.6148 20.3738C9.74859 20.3738 9.04734 19.6725 9.04734 18.8063C9.04734 17.94 9.74859 17.2388 10.6148 17.2388C11.4811 17.2388 12.1824 17.94 12.1824 18.8063C12.1824 19.6725 11.4811 20.3738 10.6148 20.3738ZM12.1824 8.82372H9.06109V3.19995H12.1824V8.82372Z"
      />
    </svg>
  </DefaultIconWrapper>
);
